import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCompanyInfo = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("g", {
		transform: "translate(0 1.5) scale(1.5)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M8.32833 6.19333H11.7443C12.5415 6.19333 12.94 6.19333 13.2445 6.34847C13.5123 6.48493 13.7301 6.70267 13.8665 6.97049C14.0217 7.27496 14.0217 7.67353 14.0217 8.47067V13.31M8.32833 13.31V2.77733C8.32833 1.98019 8.32833 1.58162 8.1732 1.27715C8.03674 1.00934 7.819 0.791594 7.55118 0.655134C7.24671 0.5 6.84814 0.5 6.051 0.5H3.489C2.69186 0.5 2.29329 0.5 1.98882 0.655134C1.721 0.791594 1.50326 1.00934 1.3668 1.27715C1.21167 1.58162 1.21167 1.98019 1.21167 2.77733V13.31M14.7333 13.31H0.5M3.7025 3.34667H5.8375M3.7025 6.19333H5.8375M3.7025 9.04H5.8375",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	})]
});
const ForwardRef = forwardRef(SvgCompanyInfo);
export default ForwardRef;
